import React from 'react';
import Modal, { modalTemplates } from '../../components/Modal';

const CreateOrderLoadingModal = ({ loading, error, closeModal }) => {
	if (!loading && !error) {
		return null;
	}

	return (
		/**
		 * `{...(!!error && { doConfirm: null })}` will pass a null doConfirm prop when error is true. This
		 * allows the modal to be closed by clicking outside of it or pressing Escape.
		 */
		<Modal modalHidden={closeModal} {...modalTemplates.BlankRoundedCentered} {...(!!error && { doConfirm: null })}>
			{!error && (
				<>
					<i
						className="fa fa-spinner fa-spin fa-fw mb-20 mt-10"
						aria-hidden="true"
						style={{ fontSize: '4em' }}
					></i>
					<p>Creating a new order with your custom profiles...</p>
				</>
			)}
			{error && (
				<>
					<p className="text-danger mt-20">An unexpected error has occurred. Please try again.</p>
					<button className="btn rounded-pill btn-default" onClick={closeModal}>
						Close
					</button>
				</>
			)}
		</Modal>
	);
};

export default CreateOrderLoadingModal;
